import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

import { CapitalizePipe } from './capitalize.pipe';
import { LinkifyPipe } from './linkify.pipe';
import { MapToIterablePipe } from './map-to-iterable.pipe';
import { TruncatePipe } from './truncate.pipe';
import { UriComponentPipe } from './uri-component.pipe';
import { KeysPipe } from './keys.pipe';

import { TimeAgoPipe } from './time-ago.pipe';
import { PrettifyPipe } from './prettify.pipe';
import { SafeHtmlPipe } from './safehtml.pipe';
import { InitDirective } from './init.directive';
import { nl2brPipe } from './nl2br.pipe';

import { I18ntexttranslatePipe } from './i18ntexttranslate.pipe';
import { DonutComponent } from './donut/donut.component';
import { ItcTagComponent } from './itc/tag/itc-tag.component';
import { TruncateTextDirective } from './truncateText.directive';

@NgModule({
    imports: [CommonModule, FormsModule, RouterModule, TruncateTextDirective],
    declarations: [
        CapitalizePipe,
        LinkifyPipe,
        MapToIterablePipe,
        TruncatePipe,
        KeysPipe,
        UriComponentPipe,
        TimeAgoPipe,
        PrettifyPipe,
        SafeHtmlPipe,
        InitDirective,
        I18ntexttranslatePipe,
        DonutComponent,
        nl2brPipe,
        ItcTagComponent,
    ],
    exports: [
        CapitalizePipe,
        LinkifyPipe,
        MapToIterablePipe,
        TruncatePipe,
        KeysPipe,
        UriComponentPipe,
        TimeAgoPipe,
        PrettifyPipe,
        SafeHtmlPipe,
        InitDirective,
        I18ntexttranslatePipe,
        DonutComponent,
        nl2brPipe,
        ItcTagComponent,
        TruncateTextDirective,
    ],
    providers: [],
})
export class SharedModule {}
